import type { LinePriceCalc } from '../../types/@types/order';

export default function LinePriceBreakdown({ calc }: { calc?: LinePriceCalc }) {
  if (!calc) return null;
  return (
    <div className="mt-3 text-sm border-t pt-2 space-y-1">
      <div className="flex justify-between"><span>Base</span><span>${calc.base}</span></div>
      {calc.flavors !== 0 && (
        <div className="flex justify-between"><span>Sabores</span><span>${calc.flavors}</span></div>
      )}
      {calc.additions !== 0 && (
        <div className="flex justify-between"><span>Adiciones</span><span>${calc.additions}</span></div>
      )}
      {calc.exceptions !== 0 && (
        <div className="flex justify-between"><span>Excepciones</span><span>${calc.exceptions}</span></div>
      )}
      <div className="flex justify-between font-semibold"><span>Total</span><span>${calc.final}</span></div>
    </div>
  );
}
